import ajax from '@/resources/myApi';
import vm from '@/main';

const service = {
  getNcmCodes,
  manageNcmCodes,
  deleteNcmCodes,
};

async function getNcmCodes() {
  try {
    const { data } = await ajax.get(`api/NCMCode`, {
      name: 'NCMCode',
      params: { pageNumber: 0, pageSize: 1 },
    });
    return data.items;
  } catch (error) {
    console.log('API Catch:',error.message);
    return { items: [], paging: {} };
  }
}

async function manageNcmCodes(dto) {
  try {
    if (dto.id) {
      var { data } = await ajax.put(`api/NCMCode/${dto.id}`, {
        name: 'NCMCode',
        body: dto,
      });
    } else {
      var { data } = await ajax.post(`api/NCMCode`, {
        name: 'NCMCode',
        body: dto,
      });
    }

    if (data.id) {
      vm.$snotify.success((dto.id) ? 'NCMCode changes saved' : 'NCMCode has been created', 'NCMCode');

      return data.id;
    }
  } catch (error) {
    console.log('API Catch:',error.message);
    return {}
  }
}

async function deleteNcmCodes(id) {
  try {
    await ajax.delete(`api/NCMCode/${id}`);
    vm.$snotify.success('NCMCode has been removed', 'NCMCode');
  } catch (error) {
    console.log('API Catch:',error.message);
  }
}

export default service;
